export default __webpack_public_path__ + "static/media/loryGameplay1.d3160daa.png";